import { useEffect, useRef, useCallback } from "react";
import { throttle } from "lodash";

// 定义useOptimizedScroll的类型
interface UseOptimizedScrollOptions {
    onScroll?: () => void;
    onScrollEnd?: () => void;
    delay?: number;
}

const useOptimizedScroll = ({
    onScroll,
    onScrollEnd,
    delay = 200,
}: UseOptimizedScrollOptions): void => {
    const isScrolling = useRef<boolean>(false);
    const scrollTimeout = useRef<number | null>(null);

    const handleScroll = useCallback(() => {
        if (onScroll) {
            if (!isScrolling.current) {
                isScrolling.current = true;
                // 使用 requestAnimationFrame 进行更平滑的滚动处理
                requestAnimationFrame(() => {
                    onScroll();
                    isScrolling.current = false;
                });
            }
        }

        if (onScrollEnd) {
            if (scrollTimeout.current !== null) {
                clearTimeout(scrollTimeout.current);
            }
            scrollTimeout.current = window.setTimeout(onScrollEnd, delay);
        }
    }, [onScroll, onScrollEnd, delay]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (scrollTimeout.current !== null) {
                clearTimeout(scrollTimeout.current);
            }
        };
    }, [handleScroll]);
};

export default useOptimizedScroll;
